module.exports = __webpack_public_path__ + "img/single-4.ea929ef2.png";